import { ColorName } from "@zapier/design-system";
import { AssetType } from "@zapier/canvas-state";

export function getContrastingTextColor(backgroundColor: string): ColorName {
  // Remove "#" if present
  const cleanHex = backgroundColor.replace(/^#/, "");

  // Parse RGB components
  const r = parseInt(cleanHex.slice(0, 2), 16);
  const g = parseInt(cleanHex.slice(2, 4), 16);
  const b = parseInt(cleanHex.slice(4, 6), 16);

  // Calculate luminance
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  // Return appropriate color token based on luminance
  return luminance > 0.6 ? "BrandEarth" : "GrayWarm1";
}

export function getBackgroundColorByType(
  assetType: AssetType | null,
  color: string | undefined,
): string {
  if (color) {
    return color;
  }

  let backgroundColor = "";

  if (assetType === "table") {
    backgroundColor = "#2b2358"; // --zds-colors-night from footer background
  } else if (assetType === "interface") {
    backgroundColor = "#c1b7ff"; // From CSS
  } else if (assetType === "zap") {
    backgroundColor = "#ffbf6e"; // From CSS
  } else if (assetType === "chatbot") {
    backgroundColor = "#cde4e1"; // From CSS
  }

  // Normalize 3-digit hex to 6-digit
  if (/^#?[0-9A-F]{3}$/i.test(backgroundColor)) {
    backgroundColor = backgroundColor.replace(
      /^#?([0-9A-F])([0-9A-F])([0-9A-F])$/i,
      "#$1$1$2$2$3$3",
    );
  }

  return backgroundColor;
}
